import { useQuery } from '@tanstack/react-query';
import { getLegalDocumentsVisibility, legalDocumentsQueryKeys } from '../lib/legalDocuments';
import { tokenManager } from '../lib/api';

/**
 * 「법정 서류 관리」 메뉴·페이지를 열지 — 서버 `GET /legal-documents/visibility`의 답 하나.
 *
 * 메뉴(`Layout`의 `flagGates`)와 페이지(`pages/legal-documents`)가 **같은 훅**을 읽는다 — 내비는 페이지
 * 게이트의 거울이라(`components/layoutNavVisibility.ts` doc) 출처가 갈리면 막다른 길이나 dead grant가 된다.
 *
 * `visible`은 **조회가 성공해 true가 온 때만** true다 — 로딩·실패(서버 미배포 404 포함)는 전부 false.
 * `isResolved`는 페이지가 「아직 모른다」와 「안 보인다」를 가르는 데 쓴다(앞쪽에서 튕기면 새로고침
 * 때마다 `/`로 밀린다).
 */
export function useLegalDocumentsVisibility(companyId: string | undefined) {
  const enabled = !!tokenManager.getAccessToken() && !!companyId;
  const query = useQuery({
    // 조직을 바꾸면 답이 바뀐다(「보는 사람의 조직이 켜졌나」가 그 축의 절반이다)
    queryKey: legalDocumentsQueryKeys.visibility(companyId ?? ''),
    queryFn: () => getLegalDocumentsVisibility(companyId!),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  return {
    visible: enabled && query.data?.visible === true,
    // 조회를 안 하는 상태(토큰·멤버십 없음)도 «판정 끝 — 안 보임»이다(영원히 로딩에 머물지 않게)
    isResolved: !enabled || query.isSuccess || query.isError,
  };
}
